import Header from "../Header/Header"
import "./aboutMe.css"

const AboutMe = () => {
    return (
        <>
            <Header />
            <div className="full-screen-container">
                {/* <div className="camera-bg">
                    <div className="camera camera-1">📷</div>
                    <div className="camera camera-2">📸</div>
                    <div className="camera camera-3">📹</div>
                    <div className="camera camera-4">📷</div>
                    <div className="camera camera-5">📸</div>
                    <div className="camera camera-6">📹</div>
                    <div className="camera camera-7">📷</div>
                    <div className="camera camera-8">📸</div>
                    <div className="camera camera-9">📹</div>
                    <div className="camera camera-10">📷</div>
                    <div className="camera camera-12">📹</div>
                    <div className="camera camera-13">📷</div>
                    <div className="camera camera-14">📸</div>
                    <div className="camera camera-15">📹</div>
                    <div className="camera camera-16">📷</div>
                    <div className="camera camera-17">📸</div>
                    <div className="camera camera-18">📹</div>
                    <div className="camera camera-19">📷</div>
                    <div className="camera camera-20">📸</div>
                </div> */}
                <div className="about-me-container">
                    <img src="/assets/NBH_9041.jpg" alt="About Me" />

                    <div className="about-me-details">
                        <h2>About Me</h2>
                        <div data-aos="fade-up"
                            data-aos-offset="100"
                        >My name is Jack Yammouni, a videographer and photographer from Beirut, Lebanon, with a background in Radio, Television, and Film.</div>

                        <div data-aos="fade-up"
                            data-aos-offset="200"
                        >I focus on visual storytelling with cinematography style, guided by intention, light, and timing. I have worked on documentaries, events, and ads.</div>


                    </div>
                </div>
            </div>
        </>
    )
}

export default AboutMe